import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6494b084")

_pushScopeId("data-v-6494b084")
const _hoisted_1 = {
  key: 0,
  class: "request-response view-card",
  id: "requestResponse"
}
const _hoisted_2 = { class: "view-card__header" }
const _hoisted_3 = { class: "view-card__header__top" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "title -bold" }, "의사회신", -1)
const _hoisted_5 = { class: "insertDate -royalBlue -bold" }
const _hoisted_6 = { class: "view-card__header__mid" }
const _hoisted_7 = { class: "doctor-item-detail" }
const _hoisted_8 = { class: "-medium" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "button" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 저장하기 ")
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_14 = { class: "view-card__body" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "label" }, "결과", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "label" }, "처방전 보기", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_DoctorItem = _resolveComponent("DoctorItem")
  const _component_FileList = _resolveComponent("FileList")

  return (!_ctx.state.isLoading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.responseDate), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            (!!_ctx.state.doctor)
              ? (_openBlock(), _createBlock(_component_DoctorItem, {
                  key: 0,
                  doctor: _ctx.state.doctor,
                  isDetail: false
                }, {
                  detail: _withId(() => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_8, [
                          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.state.doctor.DoctorName), 1),
                          _createVNode("span", _hoisted_10, _toDisplayString(_ctx.state.doctor.DeptName), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_11, [
                        _createVNode(_component_Button, {
                          class: "-button",
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = 
                    () => {
                      _ctx.createPDF();
                    }
                  )
                        }, {
                          default: _withId(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["doctor"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode("ul", null, [
            _createVNode("li", null, [
              _hoisted_15,
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.result), 1)
            ]),
            (_ctx.isPxFiles)
              ? (_openBlock(), _createBlock("li", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_FileList, {
                    class: "upload-files",
                    list: _ctx.pxFiles,
                    id: _ctx.state.id,
                    requestKind: _ctx.state.kind,
                    isPx: _ctx.isPxFiles
                  }, null, 8, ["list", "id", "requestKind", "isPx"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})